import React from "react";
import { PackageResponse } from "../../app/models/responseModels/packageResponse";

interface PackageEventsProps {
  packageRowData: PackageResponse;
}

const PackageEvents = ({ packageRowData }: PackageEventsProps) => {
  return <div>PackageEvents</div>;
};

export default PackageEvents;
